import { browser, dev } from '$app/environment';
// import { version } from '../../package.json';

export const APP_NAME = ' ';

export const WEBUI_HOSTNAME = browser ? (dev ? `${location.hostname}:8080` : ``) : '';
export const WEBUI_BASE_URL = browser ? (dev ? `http://${WEBUI_HOSTNAME}` : ``) : ``;
export const WEBUI_API_BASE_URL = `${WEBUI_BASE_URL}/api/v1`;

export const OLLAMA_API_BASE_URL = `${WEBUI_BASE_URL}/ollama`;
export const OPENAI_API_BASE_URL = `${WEBUI_BASE_URL}/openai`;
export const GEMINI_API_BASE_URL = `${WEBUI_BASE_URL}/gemini`;
export const CLAUDE_API_BASE_URL = `${WEBUI_BASE_URL}/claude`;
export const AUDIO_API_BASE_URL = `${WEBUI_BASE_URL}/audio/api/v1`;
export const IMAGES_API_BASE_URL = `${WEBUI_BASE_URL}/images/api/v1`;
export const RAG_API_BASE_URL = `${WEBUI_BASE_URL}/rag/api/v1`;
export const SARVAM_API_BASE_URL = `${WEBUI_BASE_URL}/sarvam`;
export const ZAI_API_BASE_URL = `${WEBUI_BASE_URL}/zai`;
export const MISTRAL_API_BASE_URL = `${WEBUI_BASE_URL}/mistral`;
export const X_API_BASE_URL = `${WEBUI_BASE_URL}/x`;
export const VLLM_API_BASE_URL = `${WEBUI_BASE_URL}/vllm`;

export const WEBUI_VERSION = APP_VERSION;
export const WEBUI_BUILD_HASH = APP_BUILD_HASH;
export const REQUIRED_OLLAMA_VERSION = '1.0.0';

export const COGNITO_TOKEN_SIGNING_KEY_URL="https://cognito-idp.us-east-1.amazonaws.com/us-east-1_H37COWjUx/.well-known/jwks.json";
export const COGNITO_BASE_URL=process.env.COGNITO_BASE_URL || "https://gateway.audviklabs.com";
export const COGNITO_CLIENT_NAME="Realm";
export const COGNITO_CLIENT_ID=process.env.COGNITO_CLIENT_ID || "1382il318g68a4m5l8405p047m";
export const COGNITO_SIGNIN_URL= process.env.VITE_COGNITO_SIGNIN_URL || "https://gateway.audviklabs.com/oauth2/authorize?identity_provider=NexusTeam&redirect_uri="+location.origin+"/auth&response_type=CODE&client_id=1382il318g68a4m5l8405p047m&scope=email%20openid%20phone";
//"https://gateway.audviklabs.com/login?client_id=3u1fj2703m1ur7aim60hnfdqei&response_type=code&scope=email+openid+phone&redirect_uri="+location.origin+"/auth";

// export const COGNITO_SIGNIN_URL="https://gateway.audviklabs.com/oauth2/authorize?identity_provider=NexusTeam&redirect_uri=https://nexusai.crompton.co.in/auth&response_type=CODE&client_id=1382il318g68a4m5l8405p047m&scope=email%20openid%20phone";
// "https://gateway.audviklabs.com/login?client_id=1382il318g68a4m5l8405p047m&response_type=code&scope=email+openid+phone&redirect_uri=https://nexusai.crompton.co.in/auth";

export const SUPPORTED_FILE_TYPE = [
	'application/epub+zip',
	'application/pdf',
	'text/plain',
	'text/csv',
	'text/xml',
	'text/html',
	'text/x-python',
	'text/css',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/octet-stream',
	'application/x-javascript',
	'text/markdown',
	'audio/mpeg',
	'image/jpeg',
	'image/png',
	'image/jpg',
	'image/gif',
	'image/bmp',
	'image/webp',
	'audio/wav'
];

export const SUPPORTED_FILE_EXTENSIONS = [
	'png',
	'webp',
	'bmp',
	'gif',
	'jpg',
	'jpeg',
	'md',
	'rst',
	'go',
	'py',
	'java',
	'sh',
	'bat',
	'ps1',
	'cmd',
	'js',
	'ts',
	'css',
	'cpp',
	'hpp',
	'h',
	'c',
	'cs',
	'htm',
	'html',
	'sql',
	'log',
	'ini',
	'pl',
	'pm',
	'r',
	'dart',
	'dockerfile',
	'env',
	'php',
	'hs',
	'hsc',
	'lua',
	'nginxconf',
	'conf',
	'm',
	'mm',
	'plsql',
	'perl',
	'rb',
	'rs',
	'db2',
	'scala',
	'bash',
	'swift',
	'vue',
	'svelte',
	'doc',
	'docx',
	'pdf',
	'csv',
	'txt',
	'xls',
	'xlsx',
	'pptx',
	'ppt',
	'msg'
];

// Source: https://kit.svelte.dev/docs/modules#$env-static-public
// This feature, akin to $env/static/private, exclusively incorporates environment variables
// that are prefixed with config.kit.env.publicPrefix (usually set to PUBLIC_).
// Consequently, these variables can be securely exposed to client-side code.
// console.log("Realm setup for ", COGNITO_SIGNIN_URL);
